import { pieceTypes } from "../../../../../constants";

const pieceTypeOptions = Object.entries(pieceTypes).map(([key, value]) => ({
  label: key,
  value: value.value,
}));

function PieceTypeFilter({ column: { setFilter, filterValue } }) {
  const handleOnChange = (event) => {
    setFilter(event.target.value || "");
  };

  return (
    <select
      className="form-control form-control-sm order-history-table-filters"
      value={filterValue || ""}
      onChange={handleOnChange}
    >
      <option value="">All</option>

      {pieceTypeOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

export default PieceTypeFilter;
